import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'signup',
  label: 'Signup Section',
  description: 'Registration form with phone/OTP flow and two-column layout.',
  supportedPages: ['signup'],
  variants: [{ id: 'v2', label: 'V2 (Two Column)' }],
  commonFields: [
    { key: 'redirectUrl', label: 'Redirect After Signup', type: 'string', default: '/account' },
  ],
}
